class DcCounterGroup {
  constructor(root) {
    this.root = root;
    this.values = [...root.querySelectorAll('.dc-stats-card__number')];
    this.duration = Number(root.dataset.dcCounterDuration || 2) * 1000;
    if (!this.values.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    this.targets = this.values.map((element) => Number(element.textContent.replace(/[^0-9.]/g, '')));
    this.values.forEach((element, index) => {
      if (Number.isFinite(this.targets[index])) element.textContent = '0';
    });
    this.observer = new IntersectionObserver(this.onIntersect, { threshold: 0.35 });
    this.observer.observe(root);
  }

  onIntersect = ([entry]) => {
    if (!entry.isIntersecting) return;
    this.observer.disconnect();
    this.startedAt = performance.now();
    this.frame = requestAnimationFrame(this.tick);
  };

  tick = (time) => {
    const progress = Math.min((time - this.startedAt) / this.duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    this.values.forEach((element, index) => {
      if (Number.isFinite(this.targets[index])) element.textContent = Math.round(this.targets[index] * eased).toLocaleString();
    });
    if (progress < 1) this.frame = requestAnimationFrame(this.tick);
  };
}

const initializeDcCounters = (scope = document) => {
  scope.querySelectorAll('[data-dc-counter="true"]').forEach((root) => {
    if (root.dataset.dcCounterInitialized === 'true') return;
    root.dataset.dcCounterInitialized = 'true';
    new DcCounterGroup(root);
  });
};

document.addEventListener('DOMContentLoaded', () => initializeDcCounters());
document.addEventListener('shopify:section:load', (event) => initializeDcCounters(event.target));
